export const YMAPS_MODULES: string[] = [
  'Map',
  'ObjectManager',
  'Clusterer',
  'templateLayoutFactory',
  'control.ZoomControl',
  'control.GeolocationControl',
  'control.RulerControl',
  'control.FullscreenControl',
  'control.Button',
  'control.RoutePanel',
  'panorama.Player',
  'panorama.locate',
  'panorama.isSupported',
  'meta',
  'route',

  // Предварительная загрузка внутренних модулей. На всякий случай.
  // Они должны и сами подгружаться, но возникают проблемы с очередностью(или синхронизацией) загрузки(или вызова) модулей.
  // Был баг с тем, что без модуля yandex.layer.poi при выключенном кэше не отрабатывали балуны.
  // Решили подгружать все те модули, что связаны с poi(point of interest), balloon, popup.

  // POI
  'yandex.layer.poi',
  'poi.fetcher',
  'poi.BalloonManager',
  'yandex.state.component.PoiBalloon',

  // Balloon
  'hotspot.layer.addon.balloon',
  'hotspot.layer.Balloon',
  'yandex.state.component.PoiBalloon',
  'Balloon',
  'map.addon.balloon',
  'balloon.component.getBalloonMode',
  'balloon.metaOptions',
  'map.Balloon',
  'sharedEntity.proxy.Balloon',

  // PopUp
  'popup.managerStorage',
  'popup.component.checkEmptiness',
  'popup.addonBuilder',
  'Popup',
  'popup.states',
  'sharedEntity.proxy.Popup',

  'shape.Rectangle',
  'geometry.pixel.Rectangle',

  'GeoObject',
  'GeoObjectCollection',
  'geolocation',
  'geocode',
  'suggest',

  'multiRouter.MultiRoute',
];
